module.exports = __webpack_public_path__ + "public/files/img/mails.a389391f.png";